import { useCallback, useMemo } from "react";
import useUserDefaultCollections from "collections/hooks/useUserDefaultCollections";
import { createGRN } from "logic/permissions/GRN";
const useUserDefaultCollectionsOptions = (userId) => {
  const { data, isLoading: isLoadingDefaultCollections } = useUserDefaultCollections(userId);
  const defaultCollections = useMemo(
    () => (data || []).map((collection) => ({
      label: collection.name,
      value: createGRN("collection", collection.id),
      isFixed: true
    })),
    [data]
  );
  const removeDefaultCollections = useCallback(
    (collectionOptions) => (collectionOptions || []).filter(
      (collection) => !defaultCollections.some((defaultCol) => defaultCol.label === collection.label)
    ),
    [defaultCollections]
  );
  const defaultCollectionValue = useMemo(
    () => defaultCollections.map((collection) => collection.value),
    [defaultCollections]
  );
  return {
    defaultCollections,
    removeDefaultCollections,
    defaultCollectionValue,
    isLoadingDefaultCollections
  };
};
export default useUserDefaultCollectionsOptions;
